// useTemplateString.js - Hook pour traitement des template strings
import { createContext, useContext } from 'react';

// Context pour partager les données d'item avec les composants enfants
const ItemContext = createContext(null);

export { ItemContext };

export const useItemContext = () => {
  const context = useContext(ItemContext);
  if (!context) {
    throw new Error('useItemContext must be used within ListCraft');
  }
  return context;
};

export const useTemplateString = () => {
  // Accès direct au contexte (null si pas dans ListCraft)
  const itemContext = useContext(ItemContext);

  // Fonction pour résoudre les chemins comme "item.title" ou "index"
  const resolveContextPath = (path, context) => {
    if (!context) return null;
    
    const parts = path.split('.');
    let result = context;
    
    for (const part of parts) {
      if (result && result[part] !== undefined) {
        result = result[part];
      } else {
        return null;
      }
    }
    
    return result;
  };

  // Fonction pour traiter les template strings
  const processTemplateString = (value) => {
    if (!itemContext || typeof value !== 'string' || !value.includes('${')) {
      return value;
    }

    return value.replace(/\${([^}]+)}/g, (match, path) => {
      const contextValue = resolveContextPath(path.trim(), itemContext);
      return contextValue !== null && contextValue !== undefined ? String(contextValue) : match;
    });
  };

  return { 
    processTemplateString, 
    hasContext: !!itemContext,
    itemContext
  };
};